
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * データ作成ボタン付きパネル
 */
@Component({
  components: {
    PanelFrame,
    ButtonBase,
    TitlePage,
  },
})
export default class RegistDataPanel extends Vue {
  /** ボタンクリック時のイベント */
  @Prop()
  private eventClickButton!: () => void
}
